// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_array from "../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as VehicleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/VehicleConstants.mjs";
import * as VehicleStoreEn$PorterinFeature from "../constants/VehicleStoreEn.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../constants/FareEstimateResultStoreEn.mjs";

function serviceDetails(all_services, service_category) {
  return Js_array.filter((function (service) {
                return service.service_type === service_category;
              }), all_services);
}

function createRedirectionLinkInt(service_category, city_name) {
  switch (service_category) {
    case /* TwoWheelers */0 :
        return "/bike-parcel-delivery-" + city_name;
    case /* PackersMovers */7 :
        return "/packers-and-movers/" + city_name;
    case /* Canter3Tonne */1 :
    case /* Pickup1Tonne */2 :
    case /* OneTon7Feet */3 :
    case /* Trucks */4 :
    case /* Compact */5 :
    case /* Courier */6 :
    case /* Partload */8 :
        return "/rent-mini-trucks-in-" + city_name;
    
  }
}

function createRedirectionLinkDom(service_category, city_name) {
  switch (service_category) {
    case /* TwoWheelers */0 :
        return "/two-wheelers/" + city_name;
    case /* PackersMovers */7 :
        return "/packers-and-movers/" + city_name;
    case /* Canter3Tonne */1 :
    case /* Pickup1Tonne */2 :
    case /* OneTon7Feet */3 :
    case /* Trucks */4 :
    case /* Compact */5 :
    case /* Courier */6 :
    case /* Partload */8 :
        return "/trucks/" + city_name;
    
  }
}

function getRedirectionPath(locale, service_category, city_name) {
  if (locale === "en-IN") {
    if (service_category !== 4) {
      if (service_category !== 0) {
        return "/trucks/" + city_name;
      } else {
        return "/two-wheelers/" + city_name;
      }
    } else {
      return "/trucks/" + city_name;
    }
  } else if (service_category !== 4) {
    if (service_category !== 0) {
      return "/rent-mini-trucks-in-" + city_name;
    } else {
      return "/bike-parcel-delivery-" + city_name;
    }
  } else {
    return "/rent-mini-trucks-in-" + city_name;
  }
}

function getRedirectionLink(city_data, service_category, locale) {
  var maybeService = Belt_Array.get(city_data.city_services, city_data.city_services.length - 1 | 0);
  if (maybeService !== undefined) {
    if (locale === "en-IN") {
      return createRedirectionLinkDom(service_category, city_data.city_name);
    } else {
      return createRedirectionLinkInt(service_category, city_data.city_name);
    }
  } else {
    return getRedirectionPath(locale, service_category, city_data.city_name).toLocaleLowerCase();
  }
}

function compareCitiesByName(city1, city2) {
  return $$String.compare(city1.city_name, city2.city_name);
}

function sortCitiesBasedOnName(cities, compareCitiesByName) {
  return cities.sort(Curry.__2(compareCitiesByName));
}

function sortCityServicesByName(cities) {
  return cities.sort(function (city1, city2) {
              return $$String.compare(city1.city_name, city2.city_name);
            });
}

function filterBasedOnService(all_services, service_category) {
  var service_identifier;
  switch (service_category) {
    case /* TwoWheelers */0 :
        service_identifier = VehicleStoreEn$PorterinFeature.service_category_2w;
        break;
    case /* PackersMovers */7 :
        service_identifier = VehicleStoreEn$PorterinFeature.packers_and_movers;
        break;
    case /* Canter3Tonne */1 :
    case /* Pickup1Tonne */2 :
    case /* OneTon7Feet */3 :
    case /* Trucks */4 :
    case /* Compact */5 :
    case /* Courier */6 :
    case /* Partload */8 :
        service_identifier = VehicleStoreEn$PorterinFeature.service_category_trucks;
        break;
    
  }
  var filtered_cities = Js_array.filter((function (cities) {
          var service_exists = Js_array.filter((function (service) {
                  return service.text.toLocaleLowerCase() === service_identifier.toLocaleLowerCase();
                }), cities.city_services);
          return service_exists.length !== 0;
        }), all_services);
  return filtered_cities.sort(compareCitiesByName);
}

function showStickyBasedOnScroll(heightShowFrom, setIsStickyHidden) {
  var winScroll = (document.body.scrollTop || document.documentElement.scrollTop);
  if (winScroll > heightShowFrom) {
    Curry._1(setIsStickyHidden, false);
  }
  if (winScroll < heightShowFrom) {
    return Curry._1(setIsStickyHidden, true);
  }
  
}

function getCategoryFromString(category) {
  if (category === VehicleConstants$PorterinUtils.twoWheelerString || category === VehicleConstants$PorterinUtils.courier) {
    return /* TwoWheelers */0;
  } else if (category === VehicleConstants$PorterinUtils.trucks || category === VehicleConstants$PorterinUtils.compact) {
    return /* Trucks */4;
  } else if (category === VehicleConstants$PorterinUtils.packersMovers) {
    return /* PackersMovers */7;
  } else if (category === VehicleConstants$PorterinUtils.partload) {
    return /* Partload */8;
  } else {
    return /* Trucks */4;
  }
}

function fromCategoryStringToBinding(category) {
  if (category === FareEstimateResultStoreEn$PorterinFeature.service_category_two_wheelers) {
    return VehicleConstants$PorterinUtils.twoWheelerShort;
  } else if (category === FareEstimateResultStoreEn$PorterinFeature.service_category_trucks || category !== FareEstimateResultStoreEn$PorterinFeature.service_category_partload) {
    return VehicleConstants$PorterinUtils.trucks;
  } else {
    return VehicleConstants$PorterinUtils.partload;
  }
}

function getStringFromCategory(category) {
  switch (category) {
    case /* TwoWheelers */0 :
        return FareEstimateResultStoreEn$PorterinFeature.service_category_two_wheelers;
    case /* Canter3Tonne */1 :
    case /* Pickup1Tonne */2 :
    case /* OneTon7Feet */3 :
    case /* Trucks */4 :
    case /* Compact */5 :
    case /* Courier */6 :
        return FareEstimateResultStoreEn$PorterinFeature.service_category_trucks;
    case /* PackersMovers */7 :
        return FareEstimateResultStoreEn$PorterinFeature.service_category_pnm;
    case /* Partload */8 :
        return FareEstimateResultStoreEn$PorterinFeature.service_category_partload;
    
  }
}

function getVehicleTypeFromString(category) {
  if (category === VehicleConstants$PorterinUtils.twoWheelerString || category === VehicleConstants$PorterinUtils.courier) {
    return /* TwoWheeler */1;
  } else {
    return /* Trucks */0;
  }
}

export {
  serviceDetails ,
  createRedirectionLinkInt ,
  createRedirectionLinkDom ,
  getRedirectionPath ,
  getRedirectionLink ,
  compareCitiesByName ,
  sortCitiesBasedOnName ,
  sortCityServicesByName ,
  filterBasedOnService ,
  showStickyBasedOnScroll ,
  getCategoryFromString ,
  fromCategoryStringToBinding ,
  getStringFromCategory ,
  getVehicleTypeFromString ,
}
/* No side effect */
